import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

const Bet_history_menu = ({ setSelection }) => {
  const { t } = useTranslation();

  return (
    <div>
      <ul className="nav nav-tabs history-section" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className="nav-link active"
            id="sport-tab"
            data-bs-toggle="tab"
            data-bs-target="#sport-tab-pane"
            role="tab"
            aria-controls="sport-tab-pane"
            aria-selected="true"
            onClick={() => setSelection("sport")}
          >
            {t("Sport_Coupon")}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className="nav-link"
            id="casino-tab"
            data-bs-toggle="tab"
            data-bs-target="#casino-tab-pane"
            role="tab"
            aria-controls="casino-tab-pane"
            aria-selected="false"
            tabIndex="-1"
            onClick={() => setSelection("casino")}
          >
            {t("History_bet_casino")}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Bet_history_menu;
